module.exports = __webpack_public_path__ + "energy-funders.png?b07a2445b6e44f2b0ae931b14fc2cb98";